export enum UserFormTab {
  PersonSelect = 'personSelect',
  Email = 'email',
  Roles = 'roles',
}
